import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';

const HealthcareLogin = () => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: '',
    rememberMe: false,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCredentials({
      ...credentials,
      [name]: type === 'checkbox' ? checked : value,
    });

    // Clear error when field is edited
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null,
      });
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!credentials.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(credentials.email)) {
      newErrors.email = 'Email is invalid';
    }

    if (!credentials.password) {
      newErrors.password = 'Password is required';
    } else if (credentials.password.length < 8) {
      newErrors.password = 'Password must be at least 8 characters';
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);

    // Simulate API call
    setTimeout(() => {
     
      setLoading(false);
    }, 1500);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(to bottom right, #e0f7fa, #80deea)',
      }}
    >
      <Paper elevation={3} sx={{ width: '100%', maxWidth: 600, borderRadius: 2 }}>
        <Grid container>
          {/* Left side - Animation/Image */}
          <Grid item xs={12} md={6} sx={{ background: 'linear-gradient(to bottom right, #00796b, #004d40)', color: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 4 }}>
            <Typography variant="h4" gutterBottom>
              HealthConnect
            </Typography>
            <Typography variant="body1" align="center">
              Your health, our priority
            </Typography>
            <Typography variant="body2" align="center" sx={{ marginTop: 2 }}>
              Access your medical records, appointments, and prescriptions all in one secure place.
            </Typography>
          </Grid>

          {/* Right side - Login form */}
          <Grid item xs={12} md={6} sx={{ padding: 4 }}>
            <Typography variant="h5" gutterBottom>
              Welcome Back
            </Typography>
            <Typography variant="body2" gutterBottom>
              Sign in to access your patient portal
            </Typography>

            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Email address"
                name="email"
                type="email"
                variant="outlined"
                margin="normal"
                error={!!errors.email}
                helperText={errors.email}
                value={credentials.email}
                onChange={handleChange}
              />
              <TextField
                fullWidth
                label="Password"
                name="password"
                type={showPassword ? 'text' : 'password'}
                variant="outlined"
                margin="normal"
                error={!!errors.password}
                helperText={errors.password}
                value={credentials.password}
                onChange={handleChange}
                InputProps={{
                  endAdornment: (
                    <IconButton onClick={togglePasswordVisibility}>
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  ),
                }}
              />
             <FormControlLabel
                control={
                  <Checkbox
                    name="rememberMe"
                    color="primary"
                    checked={credentials.rememberMe}
                    onChange={handleChange}
                  />
                }
                label="Remember me"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                sx={{ marginTop: 2 }}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Sign in'}
              </Button>
            </form>

            <Typography variant="body2" align="center" sx={{ marginTop: 2 }}>
              <a href="#" style={{ color: '#1976d2' }}>
                Forgot password?
              </a>
            </Typography>

            <Typography variant="body2" align="center" sx={{ marginTop: 4 }}>
              New to our service?{' '}
              <a href="#" style={{ color: '#1976d2' }}>
                Create an account
              </a>
            </Typography>

            <Typography variant="caption" align="center" sx={{ marginTop: 4, color: 'gray' }}>
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  style={{ height: 20, width: 20, color: '#4caf50', marginRight: 4 }}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  />
                </svg>
                HIPAA Compliant & Secure
              </span>
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default HealthcareLogin;